const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function phoneDigits(phone) {
  return String(phone || "").replace(/\D/g, "");
}

export function validateTrainerInviteForm(form, { requirePassword = true } = {}) {
  const errors = {};

  const fullName = String(form.fullName || "").trim();
  if (!fullName) errors.fullName = "Укажите ФИО";
  else if (fullName.length < 2) errors.fullName = "Минимум 2 символа";

  const email = String(form.email || "").trim();
  if (!email) errors.email = "Укажите email";
  else if (!EMAIL_RE.test(email)) errors.email = "Некорректный email";

  const digits = phoneDigits(form.phone);
  if (digits && digits.length < 10) {
    errors.phone = "Некорректный номер — нужно 10 цифр";
  }

  const needPassword = requirePassword;

  const password = String(form.password || "");
  if (needPassword && !password) errors.password = "Укажите пароль";
  else if (password && password.length < 8) {
    errors.password = "Минимум 8 символов";
  }

  return errors;
}

export function firstFieldError(errors) {
  return (
    errors.fullName ||
    errors.email ||
    errors.phone ||
    errors.password ||
    null
  );
}
